import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import placeImg from '@/assets/img/placeholder.jpg';

/**
 * 图片懒加载
 * @param placeholderSrc string 占位图片路径
 * @param className string className
 * @param threshold number px 组件在它出现在视口中之前就开始加载
 *
 */
const ImageLazyload = ($$: any) => {
  const { src, alt, width, height, placeholderSrc, threshold, className, ...rest } = $$;

  return (
    <LazyLoadImage
      src={src}
      alt={alt}
      width={width}
      height={height}
      placeholderSrc={placeholderSrc || placeImg}
      threshold={threshold || 200}
      wrapperClassName={className}
      {...rest}
    />
  );
};

export default ImageLazyload;
